import data from "../../../../../src/Header.docs.json";
import * as React from 'react';
export default {
  data,
  React
};